export const BUG_REPORT_ADMIN_EMAIL = 'bobby@oneblueox.com';

export function isBugReportAdmin(user) {
  return String(user?.email || '').trim().toLowerCase() === BUG_REPORT_ADMIN_EMAIL;
}
